export default function setRootProperty(name, value) {
  const root = document.querySelector(':root');
  root.style.setProperty(`--${name}`, `${value}px`);
}
